define('apps/admin/application',[
    'apps/admin/views/layout',
], function(LayoutView) {
    'use strict';

    return Mn.Application.extend({

        "initialize": function(){
            var layoutView = new LayoutView();
            layoutView.render();
        }
    });
});

